__turbopack_context__.v({
  "callMe": "CallMe-module-scss-module__GDvJGW__callMe",
  "callMe__subtitle": "CallMe-module-scss-module__GDvJGW__callMe__subtitle",
  "callMe__tel": "CallMe-module-scss-module__GDvJGW__callMe__tel",
  "callMe__textWrapper": "CallMe-module-scss-module__GDvJGW__callMe__textWrapper",
  "callMe__title": "CallMe-module-scss-module__GDvJGW__callMe__title",
});
